import { useState, useEffect } from "react";
import axios from "axios";
import GenderDonut from "./GenderDonut";
import AgeDistribution from "./AgeDistribution";

const baseUrl = process.env.REACT_APP_PUBLIC_API_URL || process.env.REACT_APP_API_URL 

const DemographicsCard = () => {
  const [demographics, setDemographics] = useState({
    male: null,
    female: null,
    total: null,
    malePercentage: null,
    femalePercentage: null,
    ageGroups: [],
    mobilityOrVisualDisabilityCount: null,
    totalDisabilityCount: null,
    totalRegistrations: null,
    disabilityPercentage: null,
  });

  useEffect(() => {
    axios
      .get(`${baseUrl}/demographics`)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setDemographics({
            male: data.male || 0,
            female: data.female || 0,
            total: data.total || 0,
            malePercentage: data.malePercentage || 0,
            femalePercentage: data.femalePercentage || 0,
            ageGroups: data.ageGroups || [],
            mobilityOrVisualDisabilityCount: data.mobilityOrVisualDisabilityCount || 0,
            totalDisabilityCount: data.totalDisabilityCount || 0,
            totalRegistrations: data.totalRegistrations || 0,
            disabilityPercentage: data.disabilityPercentage || 0,
          });
        }
      })
      .catch((error) => console.error("Error fetching demographics:", error));
  }, []);

  const donutData = [
    { name: "Male", value: demographics.male || 0 },
    { name: "Female", value: demographics.female || 0 },
  ].filter((d) => d.value > 0);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h2 className="text-lg font-semibold mb-1">Demographics Overview</h2>
      <p className="text-sm text-gray-500 mb-6">Gender Breakdown</p>

      <GenderDonut data={donutData} />

      <div className="flex justify-center gap-6 mt-4 text-sm">
        <div className="flex items-center gap-2">
          <span className="h-4 w-4 bg-yellow-400 rounded" />
          Male {demographics.malePercentage ? `${demographics.malePercentage}%` : "—"}
        </div>
        <div className="flex items-center gap-2">
          <span className="h-4 w-4 bg-green-700 rounded" />
          Female {demographics.femalePercentage ? `${demographics.femalePercentage}%` : "—"}
        </div>
      </div>

      <hr className="my-6" />

      <h3 className="font-medium mb-4">Age Distribution</h3>
      <AgeDistribution ageGroups={demographics.ageGroups} />

      <hr className="my-6" />

      <div className="flex justify-between text-sm">
        <span>Persons with Disabilities</span>
        <span className="text-green-700 font-semibold">
          {demographics.disabilityPercentage ? `${demographics.disabilityPercentage}%` : '—'}
        </span>
      </div>
      <p className="text-sm text-gray-500">
        {demographics.totalDisabilityCount && demographics.totalRegistrations
          ? `${demographics.totalDisabilityCount.toLocaleString()} of ${demographics.totalRegistrations.toLocaleString()} registrations`
          : '—'}
      </p>
    </div>
  );
};

export default DemographicsCard;